(function(){
  'use strict';
  var KEY = 'lumibrace_a11y_v2';
  var LEGACY_KEY = 'lumibrace_a11y_v1';
  var html = document.documentElement;

  /* Font scale steps (applied to <html> so every rem/em/% in the theme scales) */
  var FONT_LEVELS = [80,90,100,110,120,130,140,150];
  var DEFAULT_IDX = 2;

  var TOGGLES = [
    'contrast-high',
    'contrast-invert',
    'grayscale',
    'highlight-links',
    'highlight-titles',
    'readable-font',
    'big-spacing',
    'big-cursor',
    'reading-guide',
    'stop-animations'
  ];
  var CONTRAST_GROUP = ['contrast-high','contrast-invert','grayscale'];

  var state = { fontIdx: DEFAULT_IDX, toggles: {} };

  try {
    var raw = localStorage.getItem(KEY) || localStorage.getItem(LEGACY_KEY) || '{}';
    var saved = JSON.parse(raw);
    if(saved && typeof saved === 'object'){
      if(typeof saved.fontIdx === 'number' && saved.fontIdx >= 0 && saved.fontIdx < FONT_LEVELS.length){
        state.fontIdx = saved.fontIdx;
      }
      if(saved.toggles && typeof saved.toggles === 'object'){
        TOGGLES.forEach(function(k){ if(saved.toggles[k]) state.toggles[k] = true; });
      }
    }
  } catch(e){}

  /* Respect the OS-level reduced-motion preference by default (first visit only) */
  try {
    var stored = localStorage.getItem(KEY) || localStorage.getItem(LEGACY_KEY);
    if(!stored && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      state.toggles['stop-animations'] = true;
    }
  } catch(e){}

  function save(){ try{ localStorage.setItem(KEY, JSON.stringify(state)); }catch(e){} }

  /* ---------- media (video / animated content) ---------- */
  function applyMedia(){
    var stop = !!state.toggles['stop-animations'];
    var vids = document.querySelectorAll('video');
    for(var i = 0; i < vids.length; i++){
      var v = vids[i];
      if(stop){
        if(!v.hasAttribute('data-a11y-autoplay') && (v.autoplay || v.hasAttribute('autoplay'))){
          v.setAttribute('data-a11y-autoplay','1');
        }
        v.autoplay = false;
        try{ v.pause(); }catch(e){}
      } else if(v.getAttribute('data-a11y-autoplay') === '1'){
        v.autoplay = true;
        var p = v.play();
        if(p && p.catch) p.catch(function(){});
      }
    }
  }

  /* ---------- reading guide ---------- */
  var guideEl = null;
  function moveGuide(e){
    if(!guideEl) return;
    var y = (e.touches && e.touches[0]) ? e.touches[0].clientY : e.clientY;
    if(typeof y === 'number') guideEl.style.top = y + 'px';
  }
  function applyGuide(){
    var on = !!state.toggles['reading-guide'];
    if(on && !guideEl){
      guideEl = document.createElement('div');
      guideEl.className = 'a11y-reading-guide';
      guideEl.setAttribute('aria-hidden','true');
      (document.body || html).appendChild(guideEl);
      document.addEventListener('mousemove', moveGuide, { passive: true });
      document.addEventListener('touchmove', moveGuide, { passive: true });
    } else if(!on && guideEl){
      document.removeEventListener('mousemove', moveGuide);
      document.removeEventListener('touchmove', moveGuide);
      if(guideEl.parentNode) guideEl.parentNode.removeChild(guideEl);
      guideEl = null;
    }
  }

  function apply(){
    /* font scale on <html> — scales rem-based typography across the whole theme */
    FONT_LEVELS.forEach(function(l){ html.classList.remove('acc-font-' + l); });
    if(state.fontIdx !== DEFAULT_IDX){
      html.classList.add('acc-font-' + FONT_LEVELS[state.fontIdx]);
      html.style.setProperty('--a11y-scale', (FONT_LEVELS[state.fontIdx] / 100));
    } else {
      html.style.removeProperty('--a11y-scale');
    }

    TOGGLES.forEach(function(k){ html.classList.toggle('acc-' + k, !!state.toggles[k]); });
    html.classList.toggle('acc-active', state.fontIdx !== DEFAULT_IDX || TOGGLES.some(function(k){ return !!state.toggles[k]; }));

    var btns = document.querySelectorAll('[data-acc]');
    for(var i = 0; i < btns.length; i++){
      var btn = btns[i];
      var key = btn.getAttribute('data-acc');
      if(TOGGLES.indexOf(key) >= 0){
        btn.classList.toggle('active', !!state.toggles[key]);
        btn.setAttribute('aria-pressed', state.toggles[key] ? 'true' : 'false');
      }
    }

    var label = document.getElementById('a11y-font-level');
    if(label) label.textContent = FONT_LEVELS[state.fontIdx] + '%';

    if(document.body){ applyMedia(); applyGuide(); }
  }

  function announce(msg){
    var live = document.getElementById('a11y-live');
    if(live){ live.textContent = ''; setTimeout(function(){ live.textContent = msg; }, 60); }
  }

  function init(){
    var toggle = document.getElementById('a11y-toggle');
    var panel  = document.getElementById('a11y-panel');
    var close  = document.getElementById('a11y-close');
    if(!toggle || !panel) return;

    function focusables(){
      return Array.prototype.filter.call(
        panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        function(el){ return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    function openPanel(){
      panel.hidden = false;
      html.classList.add('a11y-panel-open');
      toggle.setAttribute('aria-expanded','true');
      var f = focusables()[0];
      if(f) f.focus();
    }
    function closePanel(returnFocus){
      panel.hidden = true;
      html.classList.remove('a11y-panel-open');
      toggle.setAttribute('aria-expanded','false');
      if(returnFocus !== false) toggle.focus();
    }

    toggle.addEventListener('click', function(){ panel.hidden ? openPanel() : closePanel(); });
    if(close) close.addEventListener('click', function(){ closePanel(); });

    document.addEventListener('keydown', function(e){
      if(panel.hidden) return;
      if(e.key === 'Escape'){ e.preventDefault(); closePanel(); return; }
      if(e.key === 'Tab'){
        /* focus trap */
        var list = focusables();
        if(!list.length) return;
        var first = list[0], last = list[list.length - 1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
        else if(!panel.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
      }
    });

    document.addEventListener('click', function(e){
      if(panel.hidden) return;
      if(panel.contains(e.target) || toggle.contains(e.target)) return;
      closePanel(false);
    });

    Array.prototype.forEach.call(panel.querySelectorAll('[data-acc]'), function(btn){
      btn.addEventListener('click', function(){
        var action = btn.getAttribute('data-acc');
        switch(action){
          case 'font-inc':   state.fontIdx = Math.min(FONT_LEVELS.length - 1, state.fontIdx + 1); break;
          case 'font-dec':   state.fontIdx = Math.max(0, state.fontIdx - 1); break;
          case 'font-reset': state.fontIdx = DEFAULT_IDX; break;
          case 'reset':
            state = { fontIdx: DEFAULT_IDX, toggles: {} };
            announce('כל הגדרות הנגישות אופסו');
            break;
          default:
            if(TOGGLES.indexOf(action) < 0) return;
            if(CONTRAST_GROUP.indexOf(action) >= 0 && !state.toggles[action]){
              CONTRAST_GROUP.forEach(function(k){ if(k !== action) state.toggles[k] = false; });
            }
            state.toggles[action] = !state.toggles[action];
            announce((btn.textContent || '').trim() + (state.toggles[action] ? ' — הופעל' : ' — בוטל'));
        }
        save();
        apply();
      });
    });

    apply();

    /* keep newly injected content (lazy sections, modals) in sync */
    if(window.MutationObserver){
      var mo = new MutationObserver(function(){ if(state.toggles['stop-animations']) applyMedia(); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* apply visual classes as early as possible (avoids a flash of unstyled state) */
  apply();

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

/* ============== Generic keyboard accessibility for site modals & mobile menu ============== */
(function(){
  'use strict';
  var lastFocus = null;

  function openDialogs(){
    var list = [];
    Array.prototype.forEach.call(document.querySelectorAll('.modal-root.open'), function(el){ list.push(el); });
    var mm = document.getElementById('mobile-menu');
    if(mm && mm.classList.contains('open')) list.push(mm);
    var sg = document.getElementById('size-guide-modal');
    if(sg && sg.getAttribute('data-open') === 'true') list.push(sg);
    return list;
  }

  function focusablesIn(el){
    return Array.prototype.filter.call(
      el.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function(n){ return !n.hasAttribute('hidden') && n.offsetParent !== null; }
    );
  }

  function closeTop(dlg){
    /* prefer the dialog's own close control so existing logic runs */
    var btn = dlg.querySelector('[data-close]:not(.modal-backdrop)') ||
              dlg.querySelector('.modal-close, #mobile-menu-close, [data-size-guide-close]') ||
              dlg.querySelector('.modal-backdrop[data-close]');
    if(btn){ btn.click(); return true; }
    return false;
  }

  document.addEventListener('keydown', function(e){
    var dlgs = openDialogs();
    if(!dlgs.length) return;
    var dlg = dlgs[dlgs.length - 1];

    if(e.key === 'Escape'){
      if(closeTop(dlg)) e.preventDefault();
      return;
    }
    if(e.key !== 'Tab') return;

    var list = focusablesIn(dlg);
    if(!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if(!dlg.contains(document.activeElement)){ e.preventDefault(); first.focus(); return; }
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  /* move focus into a dialog when it opens, and back when it closes */
  function watch(){
    if(!window.MutationObserver) return;
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        var el = m.target;
        if(!(el.classList && (el.classList.contains('modal-root') || el.id === 'mobile-menu' || el.id === 'size-guide-modal'))) return;
        var isOpen = el.classList.contains('open') || el.getAttribute('data-open') === 'true';
        if(isOpen && el.getAttribute('data-a11y-open') !== '1'){
          el.setAttribute('data-a11y-open','1');
          lastFocus = document.activeElement;
          var f = focusablesIn(el)[0];
          if(f) setTimeout(function(){ try{ f.focus(); }catch(e){} }, 30);
        } else if(!isOpen && el.getAttribute('data-a11y-open') === '1'){
          el.removeAttribute('data-a11y-open');
          if(lastFocus && document.contains(lastFocus)){ try{ lastFocus.focus(); }catch(e){} }
          lastFocus = null;
        }
      });
    });
    var targets = document.querySelectorAll('.modal-root, #mobile-menu, #size-guide-modal');
    Array.prototype.forEach.call(targets, function(t){
      mo.observe(t, { attributes:true, attributeFilter:['class','data-open'] });
    });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', watch); }
  else { watch(); }
})();
